import styled, { css } from 'styled-components'

import { AsyncStateN } from '@blade/std-lib'
import { CircularLoader } from '@blade/ui-kit'
import { Numeric } from '@blade/ui-kit'
import { type CurrencyModel } from '@root/entities/currency'
import { useTranslation } from '@root/shared/localization'

import type { Quote } from '../model'

type SwapQuoteAndFeeProps = {
  baseCurrency: CurrencyModel
  quoteCurrency: CurrencyModel
  quoteState: AsyncStateN.AsyncStateN<unknown, Quote.Quote>
}

export const QuotePrice: React.FC<SwapQuoteAndFeeProps> = ({
  quoteState,
  baseCurrency,
  quoteCurrency,
}) => {
  const { t } = useTranslation()
  const renderExchangeRate = () => {
    const oneOfBaseCurrency = (
      <>
        <span>1 {baseCurrency.ticker}</span>
        <span> = </span>
      </>
    )
    if (AsyncStateN.isNotInitiated(quoteState)) {
      return ''
    }
    if (AsyncStateN.isLoading(quoteState)) {
      return (
        <>
          <Text>{oneOfBaseCurrency}</Text>
          <CircularLoader
            css={css`
              margin-inline-start: 6px;
            `}
            size={14}
          />
        </>
      )
    }
    if (AsyncStateN.isSuccess(quoteState)) {
      return (
        <>
          <Text>
            {oneOfBaseCurrency}
            <Numeric
              value={quoteState.value.inputCurrencyPrice}
              preset="currency-amount-short"
              currency={quoteCurrency.ticker}
            />
          </Text>
        </>
      )
    }
    if (AsyncStateN.isError(quoteState)) {
      // TODO: Show proper error message
      return <>{t('common.error')}</>
    }
  }

  return <Root>{renderExchangeRate()}</Root>
}

const Root = styled.div`
  display: flex;
  align-items: center;
`

const Text = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: var(--text-11);

  & sub {
    font-size: 0.8em;
  }
`
